import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useSidebar } from "./context/sidebarContext";
import Sidebar from "./Sidebar";
import styles from "./styles/Dashboard.module.css";
import LearningSubCourse from "./components/learning/pages/SubCourseLearning";
import { baseAxios } from "./apis";
import { useCourseDetailQuery } from "./hooks/useCourse";
import Layout from "./components/ui/Layout";

// 1. Create a dedicated hook for fetching and processing a single course's details.

export const LearnSubCourse = () => {
  const navigate = useNavigate();
  const { isOpen, toggleSidebar } = useSidebar();
  const { course_id } = useParams();

  // 2. Call the new hook to get data, loading, and error states.
  const {
    data: coursesDetail,
    isLoading: loading,
    isError,
  } = useCourseDetailQuery(course_id);

  // All manual useState and data-fetching useEffect hooks are now removed.

  // Redirect if no course_id in the URL.
  useEffect(() => {
    if (!course_id) {
      navigate("/learn", { replace: true });
    }
  }, [course_id, navigate]);

  // 3. Use a separate, simple useEffect to handle side effects like navigation on error.
  useEffect(() => {
    if (isError) {
      console.error("Course not found or error fetching course details.");
      navigate("/learn", { replace: true });
    }
  }, [isError, navigate]);

  // Prevent rendering while loading or if there's no ID.
  if (!course_id || loading) {
    // You can return a loading skeleton here if you prefer
    return (
      <div className={styles.dashboard}>
        <Sidebar isOpen={isOpen} onClose={toggleSidebar} />
        <div className={styles.mainContent + " h-screen "}>
          <LearningSubCourse coursesDetail={null} loading={true} />
        </div>
      </div>
    );
  }

  // The rest of your component's JSX remains the same.
  return (
    <Layout>
      <div>
        <div className="">
          <p className="text-sm text-[#585F72] font-semibold mb-6">
            <Link to="/learn" className="text-[#0E0F11] hover:underline">
              Trading Track
            </Link>{" "}
            /{" "}
            <span className="text-[#0E0F11]/60">
              {coursesDetail?.title || "Course"}
            </span>
          </p>
        </div>
        <LearningSubCourse coursesDetail={coursesDetail} loading={loading} />
      </div>
    </Layout>
  );
};
